import {
  getReq,
  postReq,
  deleteSendReq,
  putReq,
  getCPHeaderMap,
  getHeaderCodeMap,
  END_POINTS
} from '@/api'
import * as Utils from '@/utils'

// const baseUrl = process.env.BASE_URL

const state = {
  projAcctReceiveEntityList: [],
  projAcctReceiveEntityInfo: {
    entityId: '',
    projId: '',
    entityName: '',
    entityDesc: '',
    ctrAcctId: '',
    tgtCtrAcctId: '',
    colId: '',
    entityContact: '',
    content: '',
    compId: '',
    colType: '',
    seq: 0,
    contractNo: '',
    status: '',
    entityStatus: '',
    lockBy: '',
    lockOn: new Date(0),
    crtBy: '',
    crtOn: new Date(0),
    updBy: '',
    updOn: new Date(0),
    //
    indUsed: ''
  },
  editIndex: -1,
  editAction: '',
  END_STATE: null
}

const getters = {

}

const actions = {
  async insertProjAcctReceiveEntity({
    dispatch,
    commit,
    state
  }, {projId, compId, codeParam}) {
    // debugger
    const insertObj = await postReq(END_POINTS.INSERT_RSP_PROJ_ACCT_RECEIVE_ENTITY, {
      data: {
        entityName: state.projAcctReceiveEntityInfo.entityName,
        ctrAcctId: state.projAcctReceiveEntityInfo.ctrAcctId,
        tgtCtrAcctId: state.projAcctReceiveEntityInfo.tgtCtrAcctId,
        entityContact: state.projAcctReceiveEntityInfo.entityContact,
        content: state.projAcctReceiveEntityInfo.content,
        contractNo: state.projAcctReceiveEntityInfo.contractNo,
        // status: state.projAcctReceiveEntityInfo.status,
        //
        projId: projId,
        compId: compId
      },
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return insertObj
  },
  async updateProjAcctReceiveEntityKeyInfo({
    dispatch,
    commit,
    state
  }, {entityId, projId, compId, codeParam}) {
    // debugger
    let projAcctReceiveEntityInfo = {
      entityName: state.projAcctReceiveEntityInfo.entityName,
      ctrAcctId: state.projAcctReceiveEntityInfo.ctrAcctId,
      tgtCtrAcctId: state.projAcctReceiveEntityInfo.tgtCtrAcctId,
      // entityContact: state.projAcctReceiveEntityInfo.entityContact,
      // content: state.projAcctReceiveEntityInfo.content,
      // contractNo: state.projAcctReceiveEntityInfo.contractNo,
      // status: state.projAcctReceiveEntityInfo.status,
      //
      key: {
        entityId: entityId,
        projId: projId,
        compId: compId
      }
    }
    const updateObject = await putReq(END_POINTS.UPDATE_RSP_PROJ_ACCT_RECEIVE_ENTITY_KEY_INFO, {
      data: projAcctReceiveEntityInfo,
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return updateObject
  },
  async updateProjAcctReceiveEntity({
    dispatch,
    commit,
    state
  }, {entityId, projId, compId, codeParam}) {
    let projAcctReceiveEntityInfo = {
      entityName: state.projAcctReceiveEntityInfo.entityName,
      ctrAcctId: state.projAcctReceiveEntityInfo.ctrAcctId,
      tgtCtrAcctId: state.projAcctReceiveEntityInfo.tgtCtrAcctId,
      entityContact: state.projAcctReceiveEntityInfo.entityContact,
      content: state.projAcctReceiveEntityInfo.content,
      contractNo: state.projAcctReceiveEntityInfo.contractNo,
      // status: state.projAcctReceiveEntityInfo.status,
      //
      key: {
        entityId: entityId,
        projId: projId,
        compId: compId
      }
    }
    const updateObject = await putReq(END_POINTS.UPDATE_RSP_PROJ_ACCT_RECEIVE_ENTITY, {
      data: projAcctReceiveEntityInfo,
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return updateObject
  },
  async removeProjAcctReceiveEntity({
    commit,
    state
  }, {entityId, projId, compId, codeParam}) {
    const deleteObject = await deleteSendReq(END_POINTS.REMOVE_RSP_PROJ_ACCT_RECEIVE_ENTITY + `?entityId=${entityId}&projId=${projId}&compId=${compId}`, {
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return deleteObject
  },
  async findProjAcctReceiveEntity({
    commit
  }, {entityId, projId, compId, codeParam}) {
    const responseData = await getReq(END_POINTS.FIND_RSP_PROJ_ACCT_RECEIVE_ENTITY + `?entityId=${entityId}&projId=${projId}&compId=${compId}`, {
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    if (responseData.success) {
      commit('updateProjAcctReceiveEntityInfo', responseData.data)
    } else {
      commit('updateProjAcctReceiveEntityInfo', {})
    }
  },
  async findProjAcctReceiveEntityList({
    commit,
    state,
    rootState
  }, { projId, compId, codeParam }) {
    const response = await getReq(END_POINTS.FIND_RSP_PROJ_ACCT_RECEIVE_ENTITY_LIST + `?projId=${projId}&compId=${compId}`, {
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    commit('updateProjAcctReceiveEntityList', response)
  },
  async findProjAcctReceiveEntityStatisticList({
    commit,
    state,
    rootState
  }, { projId, compId, searchedForm, codeParam }) {
    // let searchedForm = state.searchedForm || state.emptySearchInfo
    let data = {
      projId,
      compId,
      // entityName: searchedForm.searchEntityName,
      searchType: searchedForm.searchType,
      searchMonth: new Date(Utils.getMonthFirstDay(searchedForm.searchMonth)).getTime(),
      searchMonthType: searchedForm.searchMonthType,
      startDt: new Date(searchedForm.searchStartDt).getTime(),
      endDt: new Date(searchedForm.searchEndDt).getTime()
    }
    const response = await postReq(END_POINTS.FIND_RSP_PROJ_ACCT_RECEIVE_ENTITY_STATISTIC_LIST, {
      data,
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    commit('updateProjAcctReceiveEntityList', response)
  },
  END_ACTIONS() {}
}

const mutations = {
  updateProjId(state, value) {
    state.projAcctReceiveEntityInfo.projId = value
  },
  updateEntityId(state, value) {
    state.projAcctReceiveEntityInfo.entityId = value
  },
  updateEntityName(state, value) {
    state.projAcctReceiveEntityInfo.entityName = value
  },
  updateEntityDesc(state, value) {
    state.projAcctReceiveEntityInfo.entityDesc = value
  },
  updateCtrAcctId(state, value) {
    state.projAcctReceiveEntityInfo.ctrAcctId = value
  },
  updateTgtCtrAcctId(state, value) {
    state.projAcctReceiveEntityInfo.tgtCtrAcctId = value
  },
  updateColId(state, value) {
    state.projAcctReceiveEntityInfo.colId = value
  },
  updateEntityContact(state, value) {
    state.projAcctReceiveEntityInfo.entityContact = value
  },
  updateContent(state, value) {
    state.projAcctReceiveEntityInfo.content = value
  },
  updateCompId(state, value) {
    state.projAcctReceiveEntityInfo.compId = value
  },
  updateColType(state, value) {
    state.projAcctReceiveEntityInfo.colType = value
  },
  updateSeq(state, value) {
    state.projAcctReceiveEntityInfo.seq = value
  },
  updateContractNo(state, value) {
    state.projAcctReceiveEntityInfo.contractNo = value
  },
  updateStatus(state, value) {
    state.projAcctReceiveEntityInfo.status = value
  },
  updateEntityStatus(state, value) {
    state.projAcctReceiveEntityInfo.entityStatus = value
  },
  updateLockBy(state, value) {
    state.projAcctReceiveEntityInfo.lockBy = value
  },
  updateLockOn(state, value) {
    state.projAcctReceiveEntityInfo.lockOn = value
  },
  updateCrtBy(state, value) {
    state.projAcctReceiveEntityInfo.crtBy = value
  },
  updateCrtOn(state, value) {
    state.projAcctReceiveEntityInfo.crtOn = value
  },
  updateUpdBy(state, value) {
    state.projAcctReceiveEntityInfo.updBy = value
  },
  updateUpdOn(state, value) {
    state.projAcctReceiveEntityInfo.updOn = value
  },
  updateProjAcctReceiveEntityList(state, response) {
    if (response.success === true && response.data.length) {
      state.projAcctReceiveEntityList = response.data
    } else {
      state.projAcctReceiveEntityList = []
    }
  },
  updateProjAcctReceiveEntityListEmpty(state) {
    state.editIndex = -1
    state.projAcctReceiveEntityList = []
  },
  updateProjAcctReceiveEntityEmpty(state) {
    state.projAcctReceiveEntityInfo.projId = ''
    state.projAcctReceiveEntityInfo.entityId = ''
    state.projAcctReceiveEntityInfo.entityName = ''
    state.projAcctReceiveEntityInfo.entityDesc = ''
    state.projAcctReceiveEntityInfo.ctrAcctId = ''
    state.projAcctReceiveEntityInfo.tgtCtrAcctId = ''
    state.projAcctReceiveEntityInfo.colId = ''
    state.projAcctReceiveEntityInfo.entityContact = ''
    state.projAcctReceiveEntityInfo.content = ''
    state.projAcctReceiveEntityInfo.compId = ''
    state.projAcctReceiveEntityInfo.colType = ''
    state.projAcctReceiveEntityInfo.seq = 0
    state.projAcctReceiveEntityInfo.contractNo = ''
    state.projAcctReceiveEntityInfo.status = ''
    state.projAcctReceiveEntityInfo.entityStatus = ''
    state.projAcctReceiveEntityInfo.lockBy = ''
    state.projAcctReceiveEntityInfo.lockOn = new Date(0)
    state.projAcctReceiveEntityInfo.crtBy = ''
    state.projAcctReceiveEntityInfo.crtOn = new Date(0)
    state.projAcctReceiveEntityInfo.updBy = ''
    state.projAcctReceiveEntityInfo.updOn = new Date(0)

    state.projAcctReceiveEntityInfo.indUsed = ''
  },
  updateProjAcctReceiveEntityInfo(state, projAcctReceiveEntityInfo) {
    // debugger
    state.projAcctReceiveEntityInfo.projId = projAcctReceiveEntityInfo.projId
    state.projAcctReceiveEntityInfo.entityId = projAcctReceiveEntityInfo.entityId
    state.projAcctReceiveEntityInfo.entityName = projAcctReceiveEntityInfo.entityName
    state.projAcctReceiveEntityInfo.entityDesc = projAcctReceiveEntityInfo.entityDesc
    state.projAcctReceiveEntityInfo.ctrAcctId = projAcctReceiveEntityInfo.ctrAcctId
    state.projAcctReceiveEntityInfo.tgtCtrAcctId = projAcctReceiveEntityInfo.tgtCtrAcctId
    state.projAcctReceiveEntityInfo.colId = projAcctReceiveEntityInfo.colId
    state.projAcctReceiveEntityInfo.entityContact = projAcctReceiveEntityInfo.entityContact
    state.projAcctReceiveEntityInfo.content = projAcctReceiveEntityInfo.content
    state.projAcctReceiveEntityInfo.compId = projAcctReceiveEntityInfo.compId
    state.projAcctReceiveEntityInfo.colType = projAcctReceiveEntityInfo.colType
    state.projAcctReceiveEntityInfo.seq = projAcctReceiveEntityInfo.seq
    state.projAcctReceiveEntityInfo.contractNo = projAcctReceiveEntityInfo.contractNo
    state.projAcctReceiveEntityInfo.status = projAcctReceiveEntityInfo.status
    state.projAcctReceiveEntityInfo.entityStatus = projAcctReceiveEntityInfo.entityStatus
    state.projAcctReceiveEntityInfo.lockBy = projAcctReceiveEntityInfo.lockBy
    state.projAcctReceiveEntityInfo.lockOn = projAcctReceiveEntityInfo.lockOn
    state.projAcctReceiveEntityInfo.crtBy = projAcctReceiveEntityInfo.crtBy
    state.projAcctReceiveEntityInfo.crtOn = projAcctReceiveEntityInfo.crtOn
    state.projAcctReceiveEntityInfo.updBy = projAcctReceiveEntityInfo.updBy
    state.projAcctReceiveEntityInfo.updOn = projAcctReceiveEntityInfo.updOn
    //
    state.projAcctReceiveEntityInfo.indUsed = projAcctReceiveEntityInfo.indUsed
  },
  updateEditIndex(state, value) {
    state.editIndex = value
  },
  updateEditAction(state, value) {
    state.editAction = value
  },
  // newEmptyRowObj() {
  //   return {
  //     ctrAcctId: '',
  //     type: '',
  //     indUsed: '',
  //     status: ''
  //   }
  // },
  appendBottomRow() {
    this.commit('confProjAcctReceiveEntityManage/updateProjAcctReceiveEntityEmpty')
    let obj = {...state.projAcctReceiveEntityInfo}
    // debugger
    obj.isBottomRow = true
    state.projAcctReceiveEntityList.push(obj)
  },
  handleAdd(state, {row, index, ctrAcctId, tgtCtrAcctId}) {
    // debugger
    this.commit('confProjAcctReceiveEntityManage/updateProjAcctReceiveEntityEmpty')
    this.commit('confProjAcctReceiveEntityManage/updateEditIndex', index)
    this.commit('confProjAcctReceiveEntityManage/updateEditAction', 'insert')
    //
    this.commit('confProjAcctReceiveEntityManage/updateCtrAcctId', ctrAcctId)
    this.commit('confProjAcctReceiveEntityManage/updateTgtCtrAcctId', tgtCtrAcctId)
  },
  handleEdit(state, {row, index}) {
    // debugger
    this.commit('confProjAcctReceiveEntityManage/updateProjAcctReceiveEntityInfo', row)
    this.commit('confProjAcctReceiveEntityManage/updateEditIndex', index)
    this.commit('confProjAcctReceiveEntityManage/updateEditAction', 'update')
  },
  END_MUTATIONS() {}
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/proj/project/confProjAcctReceiveEntityManage.js